import React, { useState, type SyntheticEvent } from 'react';
import Button from '@atlaskit/button/new';
import { Inline, xcss } from '@atlaskit/primitives';
import { useIntl } from '@atlassian/jira-intl';
import { IDEAS_COUNT_LIMIT } from '@atlassian/jira-polaris-component-collections/src/common/constants.tsx';
import { IdeaCounter } from '@atlassian/jira-polaris-component-collections/src/ui/idea-counter/index.tsx';
import messages from './messages.tsx';

export type FooterProps = {
	submitting?: boolean;
	ideasCount?: number;
	isIdeasCountLoading?: boolean;
};

export const Footer = ({ submitting, ideasCount, isIdeasCountLoading }: FooterProps) => {
	const { formatMessage } = useIntl();
	const [isLimitWarningPopupOpen, setIsLimitWarningPopupOpen] = useState(false);
	const openWarningPopup = (e: SyntheticEvent) => {
		e.stopPropagation();
		setIsLimitWarningPopupOpen(true);
	};

	const exceedsIdeasLimit = !isIdeasCountLoading && !!ideasCount && ideasCount > IDEAS_COUNT_LIMIT;

	return (
		<Inline xcss={footerStyles} alignInline="end" space="space.200" alignBlock="start">
			<IdeaCounter
				ideasCount={ideasCount}
				isIdeasCountLoading={isIdeasCountLoading}
				exceedsLimit={exceedsIdeasLimit}
				isLimitWarningPopupOpen={isLimitWarningPopupOpen}
				setIsLimitWarningPopupOpen={setIsLimitWarningPopupOpen}
				onOpenWarningPopup={openWarningPopup}
			/>
			<Button
				testId="polaris-component-collection-create.ui.form.footer.button"
				type={exceedsIdeasLimit ? 'button' : 'submit'}
				appearance="primary"
				isLoading={submitting}
				onClick={exceedsIdeasLimit ? openWarningPopup : undefined}
			>
				{formatMessage(messages.createButtonLabel)}
			</Button>
		</Inline>
	);
};

const footerStyles = xcss({
	marginBlock: 'space.200',
});
